module.exports = __webpack_public_path__ + "static/What-to-Expect-During-a-Session-e15001b7c72626b047eb2c16907ba6fb.webp";